import * as actionTypes from '../actions/actionTypes';
import { formatOption } from '../../utils/formatters/formik-grape-formatter';

export const initialState = {
  brandProfileId: null,
  eligibleUsers: null,
  confirmModalOpen: false,
  currentJobId: null,
  currentJobStatus: null,
  persistedJobStatuses: {},
  stories: null
};

const setNewStatus = (state, action) => {
  const newStatuses = { ...state.persistedJobStatuses };
  newStatuses[state.brandProfileId] = {
    jobId: action.jobId,
    fromUser: action.fromUser,
    toUser: action.toUser
  };
  return newStatuses;
};

const deleteStatus = (state) => {
  const updatedStatuses = { ...state.persistedJobStatuses };
  delete updatedStatuses[state.brandProfileId];
  return updatedStatuses;
};

const reducer = (state = initialState, action) => {
  switch (action.type) {
    case actionTypes.SET_BRAND_PROFILE_ID:
      return {
        ...state,
        brandProfileId: action.brandProfileId
      };
    case actionTypes.SET_STORIES:
      return {
        ...state,
        stories: action.stories
      };
    case actionTypes.SET_ELIGIBLE_USERS:
      return {
        ...state,
        eligibleUsers: action.users.map(user => formatOption(user.staffer))
      };
    case actionTypes.TOGGLE_CONFIRM_MODAL:
      return {
        ...state,
        confirmModalOpen: !state.confirmModalOpen
      };
    case actionTypes.SET_JOB_ID:
      return {
        ...state,
        currentJobId: action.jobId
      };
    case actionTypes.SET_JOB_STATUS:
      return {
        ...state,
        currentJobStatus: action.jobStatus
      };
    case actionTypes.SET_PERSISTED_JOB_STATUS:
      return {
        ...state,
        persistedJobStatuses: setNewStatus(state, action)
      };
    case actionTypes.REMOVE_PERSISTED_JOB_STATUS:
      return {
        ...state,
        persistedJobStatuses: deleteStatus(state)
      };
    default: return state;
  }
};

export default reducer;



// WEBPACK FOOTER //
// ./app/javascript/app/store/reducers/reassign_users.js